import React from 'react';
import { DataTable } from 'primereact/datatable';
import {Column} from "primereact/column";
import './estilos_tabelas.css';


class ListagemEmpreendimentos extends React.Component {

    constructor(props) {
        super(props);
        this.colunas = [
            { field: 'name', header: 'Nome' },
            { field: 'type', header: 'Tipo' },
            { field: 'status', header: 'Status', badge: true },
            { field: 'builder_name', header: 'Construtora' },
            { field: 'incorporadoras', header: 'Incorporadoras' },
            { field: 'date_sale_start_formatted', header: 'Dt. Lançamento' },
            { field: 'address', header: 'Endereço' },
            { field: 'neighborhood', header: 'Bairro' },
            { field: 'city_name', header: 'Cidade' },
            { field: 'city_state', header: 'Estado' },
            { field: 'created_at_formatted', header: 'Dt. Cadastro' },
        ]
    }

    formatLabel = ( value )=>{
        value = value.status;
        if( value === 'Ativo'){
            return <span className="badge badge-success">{value}</span>;
        }

        if( value === 'Esgotado' || value === 'Esgotado Incompleto' || value === 'Refutado'){
            return <span className="badge badge-danger">{value}</span>;
        }

        if( value === 'Suspendo' || value === 'Cooperativa'){
            return <span className="badge badge-warning">{value}</span>;
        }

        if( value === 'Futuro' || value === 'Lançado'){
            return <span className="badge badge-warning">{value}</span>;
        }

        return value;

    }


    formatIncorporadoras = ( rowValue )=>{

        let incorporadoras = rowValue.incorporators.map((incorporadora) => {
            return (
                incorporadora.name
            )
        });

        return (
            <div>
                {incorporadoras.join(', ')}
            </div>
        )
    }

    formatLinkEmpreendimento = ( rowValue )=>{
        return (
            <a href={ route('building.show', rowValue.id ) } target="_blank" rel="noopener noreferrer" className="btn-link">
                {rowValue.name} &nbsp; <i className="fa fa-link"></i>
            </a>
        )
    }

    render() {
        return (
            <React.Fragment>
                <div className="datatable-responsive-demo">
                    <div className="card">
                        {!this.props.loading && this.props.empreendimentos.length === 0 && (<div className="d-flex justify-content-center align-items-center" style={{height: '40vh'}}>
                            <h4 className="text-muted">Nenhum Empreendimento Encontrado</h4>
                        </div>)}

                        {this.props.loading && (
                            <div className="d-flex justify-content-center align-items-center" style={{height: '40vh'}}>
                                <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem'}}></i>
                            </div>
                        )}

                        {!this.props.loading && this.props.empreendimentos.length > 0 && (
                            <DataTable loading={this.props.loading} value={this.props.empreendimentos} className="p-datatable-gridlines p-datatable-striped p-datatable-sm" scrollable scrollHeight="430px">
                                {this.colunas.map((coluna) => {
                                    if( coluna?.badge === true ){
                                        return (<Column key={coluna.field}  field={coluna.field} body={this.formatLabel} header={coluna.header} />)
                                    }

                                    if( coluna.field === 'incorporadoras' ){
                                        return (
                                            <Column key={coluna.field} body={this.formatIncorporadoras} field={coluna.field} header={coluna.header} />
                                        )
                                    }

                                    if( coluna.field === 'name'){
                                        return (
                                            <Column key={coluna.field} body={this.formatLinkEmpreendimento} field={coluna.field} header={coluna.header} />
                                        )
                                    }

                                    return (
                                        <Column key={coluna.field} field={coluna.field} header={coluna.header} />
                                    )
                                })}
                            </DataTable>
                        )}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ListagemEmpreendimentos;
